// extracted by mini-css-extract-plugin
export var addToCartButton = "_pr-b";
export var arrowButtonContainer = "_pr-9";
export var arrowButtonIcon = "_pr-a";
export var carouselArrowButton = "_pr-6";
export var carouselElementContainer = "_pr-1";
export var galleryThumbnail = "_pr-d";
export var galleryThumbnailImage = "_pr-e";
export var left = "_pr-7";
export var productDisplayCarouselContainer = "_pr-0";
export var productTileContainer = "_pr-2";
export var productTileImage = "_pr-4";
export var productTileImageContainer = "_pr-3";
export var productTileTitle = "_pr-5";
export var right = "_pr-8";
export var sliderOverflow = "_pr-c";